import { styled, Chip as MuiChip } from '@mui/material'

export const Chip = styled(MuiChip)<{ selected?: boolean; disabled?: boolean; size?: string }>`
  display: inline-flex;
  gap: ${({ theme, size }) => theme.spacing(size === 'small' ? 0.5 : 1)};
  padding: ${({ theme, size }) => theme.spacing(1, size === 'small' ? 1 : 1.5)};
  align-items: center;
  height: ${({ theme, size }) => theme.spacing(size === 'small' ? 4.5 : 5)};
  width: fit-content;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  background-color: ${({ theme, selected }) => (selected ? theme.palette.secondary.main : 'inherit')};
  border: ${({ theme, selected }) =>
    `${theme.spacing(0.1)} solid ${selected ? theme.palette.secondary.main : theme.palette.secondary.outlinedBorder}`};
  border-radius: ${({ theme }) => theme.spacing(12.5)};
  color: ${({ theme, selected }) => (selected ? theme.palette.textLight.primary : theme.palette.text.primary)};
  & svg {
    color: ${({ theme, selected }) => (selected ? theme.palette.secondary.light : theme.palette.secondary.main)};
  }
  &:hover {
    background-color: ${({ theme, selected }) =>
      selected ? theme.palette.secondary.dark : theme.palette.secondary.hover} !important;

    // media query to check if the user uses a touch device to avoid passing isNative
    @media (pointer: coarse) {
      background-color: ${({ theme, selected }) =>
        selected ? theme.palette.secondary.main : theme.palette.common.white} !important;
    }
  }
  &:focus {
    background-color: ${({ theme, selected }) =>
      selected ? theme.palette.secondary.dark : theme.palette.secondary.focus} !important;

    & svg {
      color: ${({ theme, selected }) => (selected ? theme.palette.secondary[100] : theme.palette.secondary.main)};
    }
  }
  & .MuiChip-deleteIcon {
    color: ${({ theme, selected }) =>
      selected ? theme.palette.secondary.light : theme.palette.secondary.main} !important;
    margin: 0;
  }
  & .MuiChip-label {
    padding: 0;
  }
`
